import React from 'react'
import PropTypes from 'prop-types'
import styles from './../style/DelaemLesnici.module.scss'
import { Container, Button, Image, Dropdown } from 'react-bootstrap'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Импортируем компонент

class DelaemLesnici extends React.Component {
  constructor(props) {
    super(props)

    var item = []
    props.list.map( ( elm, k ) => {
      if( k == 0 ) item = elm
    } )

    this.state = {
      elm: item,
      key: 0,
      show_feedback: false,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  changeElm = ( elm, k ) => {
    this.setState({
      elm: elm,
      key: k
    })
  }

  // Функция для открытия лайтбокса
  openLightbox = () => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list } = this.props,
    { elm, key, show_feedback, lightboxController } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <div className={styles.title}>
            <h2>Какие лестницы <span>мы делаем?</span></h2>
          </div>
          <div className={styles.btns}>
            {list.map( ( lelm, k ) => {
              if(lelm?.name == elm?.name) return (
                <Button as={`div`} className={styles.btn_active} key={k} variant='light'>
                  <div className={styles.btn_name}>{lelm?.name}</div>
                </Button>
              ) 
              return (
                <Button as={`div`} onClick={() => this.changeElm( lelm, k )} className={styles.btn} key={k} variant='light'>
                  <div className={styles.btn_name}>{lelm?.name}</div>
                </Button>
              )
            } )}
          </div>
          <Dropdown className={styles.dropdown}>
            <Dropdown.Toggle className={styles.dropdown_toggle} variant="primary" id="dropdown-advantages">
              <div>{elm?.name}</div>
              <svg
                width="10"
                height="5"
                viewBox="0 0 12 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.btn_icon_r}
              >
                <path d="M1 1L6 6L11 1" stroke="#fff" strokeWidth="1.5" />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {list.map( ( lelm, k ) => (
                <Dropdown.Item onClick={() => this.changeElm( lelm, k )}>{lelm?.name}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={[elm?.image]} // Массив с изображениями (в данном случае одно основное изображение)
            slide={lightboxController.slide}
          />
          
          <div className={styles.blocks}>
            <div className={styles.block_top}>
              <div>
                <div className={styles.block_top_tline}>
                  <div className={styles.block_top_tline_title} dangerouslySetInnerHTML={{__html: elm?.title}} />
                  <div>{this.formatSlideNumber(key)}</div>
                </div>
                <div className={styles.block_top_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                <GreenButton
                  text={`Узнать стоимость вашей лестницы`}
                  width={519}
                  action={() => this.showFeedback()}
                  className={`${styles.block_top_button} d-none d-md-flex`}
                />
                <div className={styles.block_top_materials}>
                  {elm?.materials.map( ( cel, k ) => (
                    <div key={k} className={styles.block_top_materials_el}>
                      <Image 
                        className={styles.block_top_materials_el_image} 
                        src={cel?.image} 
                        width={122} 
                        height={50} 
                        alt={cel?.name} 
                      />
                      <div className={styles.block_top_materials_el_name} dangerouslySetInnerHTML={{__html: cel?.name}} />
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Оборачиваем изображение в кликабельный элемент */}
              <div onClick={this.openLightbox} style={{cursor: 'pointer'}}>
                <Image 
                  className={styles.block_top_image} 
                  src={elm?.image} 
                  width={601} 
                  height={205} 
                  alt={elm?.name} 
                  style={{cursor: 'pointer'}}
                />
              </div>
              
              <GreenButton
                text={`Узнать стоимость вашей лестницы`}
                width={519}
                action={() => this.showFeedback()}
                className={`${styles.block_top_button} d-md-none`}
              />
            </div>
            <div className={styles.block_bottom}>
              <div className={styles.block_bottom_left} dangerouslySetInnerHTML={{__html: elm?.btext}} />
              <div className={styles.block_bottom_right}>
                <div className={styles.block_bottom_right_top}>
                  <div className={styles.block_bottom_right_top_sep} />
                  <div className={styles.block_bottom_right_top_title}>Акция</div>
                </div>
                <div className={styles.block_bottom_right_title} dangerouslySetInnerHTML={{__html: elm?.atitle}} />
                <div className={styles.block_bottom_right_text} dangerouslySetInnerHTML={{__html: elm?.atext}} />
              </div>
            </div>
          </div>
        </Container>
        <FeedbackForm
          title={`Узнать стоимость вашей лестницы`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

DelaemLesnici.propTypes = {
  list: PropTypes.array
}

DelaemLesnici.defaultProps = {
  list: []
}

export default DelaemLesnici